import React from "react";

import LoginSlider from "../../components/Login/LoginSlider";
import NewPassword from "../../components/NewPassword";

function ResetPassword(){
    return(
        <>
            <div className="slick-and-login">
            <section className="login-section">
               <div className="container-fluid px-lg-5 px-md-4 px-3">
                  <div className="row d-flex justify-content-center h-100">
                     <div className="col-md-6 slider-colomn sticky-top">
                        <LoginSlider/>
                     </div>
                     <div className="col-md-6 align-self-center">
                        <NewPassword/>
                     </div>
                  </div>
               </div>
            </section>
         </div>
        </>
    )
}

export default ResetPassword;